import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWatchForm } from './useWatchForm';
import { useNavigate } from 'react-router-dom';
import { FormInstance } from 'antd';
import dayjs from 'dayjs';
import { setValues } from 'pages/process-complate-profile/redux-sagas/actions';
import { stepsData } from 'utilities/consts';
import { registrationRequest } from 'pages/profile/redux-sagas/actions';
import { User, WORKER_STATUS } from 'api';
import { ROUTE } from 'routers/data';
import { useMapperAddress } from './useMapperAddress';

type TProcessFooter = {
  step: number;
  form: FormInstance;
};
export const useProcessFooter = ({ step, form }: TProcessFooter) => {
  const userData = useSelector((state: any) => state.profile?.data);
  const registrationLoading = useSelector(
    (state: any) => state.profile?.registrationLoading,
  );
  const { getLongAddress, getShortAddressAndStreetNumber } = useMapperAddress();
  const { values } = useSelector((state: any) => state.processComplate);
  const { isValid } = useWatchForm({ form });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { street, streetNumber } = getShortAddressAndStreetNumber();

    const data = {
      terms: userData?.state === WORKER_STATUS.waitingRevision,
      ...userData,
      ...(userData.birthday && {
        birthday: dayjs(userData.birthday),
      }),
      ...(userData.worksSince && {
        worksSince: dayjs(userData.worksSince),
      }),
      streetNumber,
      address: street,
      ...values[step],
      ...(values[0].birthday && {
        birthday: dayjs(values[0].birthday),
      }),
      ...(values[1].worksSince && {
        worksSince: dayjs(values[1].worksSince),
      }),
    };

    const fieldWithError = userData.fieldsWithError?.map((key: string) => ({
      name: key,
      errors: ['Valor rechazado'],
    }));
    form.setFieldsValue(data);
    form.setFields(fieldWithError || []);

    navigator.geolocation.getCurrentPosition((position) => {
      dispatch(
        setValues({
          step: 0,
          aux: {
            currentLat: position.coords.latitude,
            currentLng: position.coords.longitude,
          },
        }),
      );
    });

    // eslint-disable-next-line
  }, [step]);

  const saveAndNext = useCallback(() => {
    if (step === 3 && WORKER_STATUS.waitingRevision === userData.state) {
      navigate(ROUTE.profileStatus);
      return;
    }
    //SAVE LOCALLY AND NEXT STEP
    const formValues = {
      ...form.getFieldsValue(),
      ...(step === 0 && {
        birthday: form.getFieldsValue().birthday?.toDate(),
      }),
      ...(step === 1 && {
        worksSince: form.getFieldsValue().worksSince?.toDate(),
      }),
    };
    const { files, ...rest } = formValues;
    dispatch(setValues({ step, values: rest, complate: { [step]: true } }));

    if (!stepsData[step].done) {
      navigate(stepsData[step].next!);
      form.resetFields();
    } else {
      const valuesToSend: Partial<User & { streetNumber: number }> =
        Object.keys(values).reduce(
          (acc, key) => ({ ...acc, ...values[key] }),
          {},
        );

      // NEXT BACKEND
      dispatch(
        registrationRequest({
          ...valuesToSend,
          ...rest,
          address: getLongAddress(),
          files,
        }),
      );
    }
  }, [dispatch, form, getLongAddress, navigate, step, userData.state, values]);

  return { saveAndNext, isValid, userData, registrationLoading };
};
